import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CardList } from '../components/CardList'
import { Loader } from '../components/Loader'
import { AuthContext } from '../context/AuthContext'
import { CardContext } from '../context/CardContext'
import { useHttp } from '../hooks/http.hook'
import Input from "../components/Input";
import {CardsExporter} from "../components/CardsExporter";



export const CardsPage = () => {
    const auth = useContext(AuthContext);
    const card = useContext(CardContext) 
    const [cards, setCards] = useState([])
    const {loading, request} = useHttp()
    const {token} = useContext(AuthContext)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')

    const fetchCards = useCallback(async()=>{
      try {
          const fetched = await request('/api/card', 'GET', null, {
              Authorization: `Bearer ${token}`
          })
          let cards = fetched?.reverse()
          setCards(cards)
      } catch (e) {
          
      }
  },[token, request])

  useEffect(()=>{
      fetchCards()
  },[fetchCards])


    const ToDate = (value) => {
        if ((value !== '') && (value)){
          value = value.slice(6, 10) + "-" + value.slice(3, 5) + "-" + value.slice(0, 2)
        }
        return value
      }
      const SetValueDate = (field, value) => {
        if (value !== ''){
          value = value.slice(8, 10) + "." + value.slice(5, 7) + "." + value.slice(0, 4)
        }
        if (field === 'from'){
            setDateFrom(value)
        }
        else{
            setDateTo(value)
        }
      }

    if (loading){
        return <Loader/>
    }
    return (
        <div>
            {!loading && <div>
                <Input
                  id="date-from"
                  type="date"
                  caption="От"
                  SetValue={SetValueDate}
                  field={'from'}
                  value={ToDate(dateFrom)}
                />
                <Input
                  id="date-to"
                  type="date"
                  caption="До"
                  SetValue={SetValueDate}
                  field={'to'}
                  value={ToDate(dateTo)}
                />
                </div>}
            <div style={{paddingTop:"1%"}} className="center">
              <CardsExporter isFilter={true} from={dateFrom} to={dateTo} cards={cards}/>
            </div>
            
        </div>
    )
}